import { render, staticRenderFns } from "./ActivateBookAssignation.vue?vue&type=template&id=8bc333dc&"
import script from "./ActivateBookAssignation.vue?vue&type=script&lang=js&"
export * from "./ActivateBookAssignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports